// Q9 S3 — Wizard step footer (Back / Next / Submit row).
// On non-review steps: shows Back + Next. Next button shows "Saving…" while
// the PATCH is in flight. On the review step: shows Back + Submit.
// Submit is disabled when any step is incomplete (Q9 D9 — submit blocks
// until all required cleared).
// D25 — silent submit; no confirm modal.

import type { JSX } from "react";

interface Props {
  isReviewStep: boolean;
  isFirstStep: boolean;
  isSaving: boolean;
  submitDisabledReason?: string | null;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export function WizardStepFooter({
  isReviewStep, isFirstStep, isSaving, submitDisabledReason, onPrev, onNext, onSubmit,
}: Props): JSX.Element {
  return (
    <div className="mt-5 flex items-center justify-between gap-3">
      <button
        type="button"
        onClick={onPrev}
        disabled={isFirstStep || isSaving}
        className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        ← Back
      </button>

      <div className="flex items-center gap-3">
        {!isReviewStep && (
          <button
            type="button"
            onClick={onNext}
            disabled={isSaving}
            className="px-5 py-2 text-sm font-medium rounded-lg bg-navy-700 text-white hover:bg-navy-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            data-testid="wizard-next"
          >
            {isSaving ? "Saving…" : "Next →"}
          </button>
        )}
        {isReviewStep && (
          <button
            type="button"
            onClick={onSubmit}
            disabled={isSaving || !!submitDisabledReason}
            title={submitDisabledReason ?? undefined}
            className="px-5 py-2 text-sm font-medium rounded-lg bg-navy-700 text-white hover:bg-navy-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            data-testid="wizard-submit"
          >
            {isSaving ? "Submitting…" : "Submit Visit Report"}
          </button>
        )}
      </div>
    </div>
  );
}
